import TopBar from "../../../components/common/topBar/TopBar.vue";

import axios from "axios";

let fileUploadFormData; // 临时保存用户上传的文件用。
//按需加载
import {
  getBimDataBankCategoryTree,
  addBimDataBankData,
  editBimDataBankData,
  getBimDataBankDataDetail,
  getFileList,
  getFileDetail,
  deleteFile,
} from "../../../api/api";

let nowProjectId;
export default {
  name: "BimDatabankData",
  components: {
    TopBar,
  },
  props: {},
  data() {
    let checkNameLength = (rule, value, callback) => {
      // if(value === ''){
      // 	callback(new Error('请输入资料项标题。'))
      // }
      if (value.length > 200) {
        callback(new Error("资料项的标题最多只允许输入两百个字。"));
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: "120px",
      pageHeaderContent: "资料上传",
      dialogTitle: "选择目录",
      dialogFormVisible: false,
      submit_disabled: false,
      form: {
        id: "",
        categoryId: "",
        categoryName: "",
        name: "",
        remarks: "",
        fileList: [], //upload多文件数组
        fileData: "", //文件上传数据（多文件合一）。
        tempFileList: [], //还未保存到服务器上的用户上传的文件。
        registerTime: "",
        newInsertId: "", //新增数据的id
        deleteFileIds: [], //用户编辑页面时删除的文件id。等用户确认提交表单后再删除服务器上文件。
      },
      title: "新增",
      rules: {
        categoryId: [
          {
            required: true,
            message: "请点击上方链接选择上传资料所属目录。",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入标题。",
            trigger: "blur",
          },
          {
            validator: checkNameLength,
            trigger: "blur",
          },
        ],
        // position: [{
        // 	required: true,
        // 	message: '右键单击地图，输入经度,维度,高程',
        // 	trigger: 'blur'
        // }],
      },
      isEdit: false,
      data: {},
      options: [],
      timeTik: "", //一个关于标记的计时器。
      tempFileList: [],
      dialogVisible: false,
      dialogImageUrl: "",

      /* 预览资料文件 */
      dialogFileUrl: "",
      categoryTreeData: [],
      defaultProps: {
        children: "children",
        label: "text",
      },

      isFirstFile: true, //不论是新增还是编辑，如果用户上传的是该资料项的第一个文件，并且表单里的资料项名称为空，那么就将第一个文件的文件名赋值给资料项名称输入框。
    };
  },
  mounted() {
    let that = this;
    nowProjectId = parseInt(window.sessionStorage.getItem("nowProjectId"));

    this.initFormData();
    // alert(this.$route.params);
    // console.log(this.$route.params);
    // console.log(JSON.parse(JSON.stringify(this.$route.params)));
    // console.log(111);
    let editId = JSON.parse(
      window.sessionStorage.getItem("BimDatabankDataEditUrlId")
    ); //避免用户刷新页面后编辑表单变成了新增表单。
    //console.log(editId);
    if (!editId) {
      if (this.$route.params?.dataId && this.$route.params.dataId > 0) {
        editId = this.$route.params.dataId;
        window.sessionStorage.setItem("BimDatabankDataEditUrlId", editId);
      }
    }

    if (editId && editId > 0) {
      this.pageHeaderContent = "编辑资料";
      this.form.id = editId;
      // 将进入此编辑页面的参数数据保存到sessionStorage里，避免页面刷新后编辑页面变成了新增页面，而用户没有发觉到。组件销毁时清空对应的值。

      getBimDataBankDataDetail({
        id: editId,
      }).then((res) => {
        //console.log(JSON.parse(JSON.stringify(res)));
        if (res.data.success) {
          that.form.name = res.data.data.title;
          that.form.remarks = res.data.data.remarks;
          that.form.registerTime = res.data.data.registerTime;
          that.form.categoryId = res.data.data.directoryId;
          that.form.categoryName = res.data.data.directoryName;

          let fileList = [];
          let tFileList = [];
          getFileList({
            businessType: "BimDataBankData",
            businessId: editId,
          }).then((res2) => {
            if (res2.data.success && res2.data.data.length > 0) {
              for (let i = 0; i < res2.data.data.length; i++) {
                let tempObj = {
                  name: res2.data.data[i].fileOriginName,
                  //如果要预览文件或下载文件则调用专门的api接口，因此这里不需要拼接出url。
                  url: "#",
                  id: res2.data.data[i].id,
                  //'url': process.env.VUE_APP_BASE_API + response.imgUrl
                };
                fileList.push(tempObj);
              }
              that.form.fileList = fileList;
            }
            //console.log(JSON.parse(JSON.stringify(res2.data)));
            //console.log(444);
          });
        } else {
          this.$alert("未查询到该资料项的详情，请再试一次吧。", "友情提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {
              // this.$router.go(-1);
              this.dialogFormVisible = true;
            },
          });
        }
        //console.log(JSON.parse(JSON.stringify(res)));
        //console.log(666);
      });
      this.isEdit = true;
    } else {
      if (!this.$route.params?.id || this.$route.params.id < 1) {
        this.$alert(
          "不可直接在根目录下新建资料项哦~，请先选择目录吧。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {
              // this.$router.go(-1);
              this.dialogFormVisible = true;
            },
          }
        );
        // return false;
      } else {
        this.form.categoryId = this.$route.params.id;
        this.form.categoryName = this.$route.params.text;
      }
      this.isEdit = false;
    }

    // 获取目录
    let getCTreeData = {
      projectId: nowProjectId,
    };

    getBimDataBankCategoryTree(getCTreeData).then((res) => {
      // console.log(JSON.parse(JSON.stringify(res)));
      // console.log(111);
      if (res.data.success && res.data.data.length > 0) {
        that.categoryTreeData = res.data.data;
      } else {
        that.categoryTreeData = [];
      }
    });
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/bimDatabank",
      });
    },
    handleNodeClick(data) {
      this.form.categoryId = data.id;
      this.form.categoryName = data.text;
      this.dialogFormVisible = false;
      //console.log(JSON.parse(JSON.stringify(data)));
      //alert(1)
    },
    initFormData() {
      this.form = {
        id: "",
        categoryId: "",
        categoryName: "",
        name: "",
        remarks: "",
        fileList: [], //upload多文件数组
        fileData: "", //文件上传数据（多文件合一）。
        tempFileList: [], //还未保存到服务器上的用户上传的文件。
        registerTime: "",
        newInsertId: "", //新增数据的id
        deleteFileIds: [], //用户编辑页面时删除的文件id。等用户确认提交表单后再删除服务器上文件。
      };
    },
    onSubmit() {
      let that = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //alert(1)
          /* 表单提交后2秒内不可重复点击 */
          that.submit_disabled = true;
          //console.log(this);
          let tempTimer = setTimeout(function() {
            that.submit_disabled = false;
            clearTimeout(tempTimer);
          }, 2000);

          if (
            that.form.fileList !== undefined &&
            that.form.fileList.length > 0
          ) {
            // this.$refs.upload.submit(); //提交调用uploadFile函数
            that.form.fileData = that.form.fileList
              .map(function(elem, index) {
                return elem.id;
              })
              .join(","); //new formData对象
          }
          let dData = {
            projectId: nowProjectId,
            directoryId: that.form.categoryId,
            remarks: that.form.remarks,
            title: that.form.name,
            // localFiles: this.form.fileData,
            registerTime: that.form.registerTime,
          };

          if (that.isEdit) {
            //alert(2)
            dData.id = that.form.id;
            editBimDataBankData(dData).then((res) => {
              if (res.data.success) {
                if (
                  that.form.tempFileList &&
                  that.form.tempFileList.length > 0
                ) {
                  //有新文件才上传，没新文件不必上传。
                  //根据资料项的id进一步上传文件。
                  let fileUploadFormData = new FormData();
                  that.form.tempFileList.forEach((item) => {
                    fileUploadFormData.append("files", item);
                  });
                  fileUploadFormData.append("businessType", "BimDataBankData");
                  fileUploadFormData.append("businessId", dData.id);
                  fileUploadFormData.append(
                    "projectId",
                    window.sessionStorage.getItem("nowProjectId")
                  );
                  // 上传新增文件。
                  axios
                    .post(
                      "/baseIP/sysFileInfo/uploadmultiple",
                      fileUploadFormData,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization:
                            "Bearer " + window.sessionStorage.getItem("token"),
                          "X-Authorization":
                            "Bearer " +
                            window.sessionStorage.getItem("refreshToken"),
                        },
                      }
                    )
                    .then(function(res2) {
                      if (res2.data.success && res2.data.data) {
                        // that.$message({
                        // 	message: '新增文件上传成功。',
                        // 	type: 'success',
                        // 	offset: 100,
                        // 	showClose: true,
                        // 	duration: 1600,
                        // });
                        console.log("新增文件上传成功。");
                        return true;
                      } else {
                        // console.log(err);
                        // console.log('文件 ' + param.file.name + ' 上传失败，请重新上传');
                        //上传失败则从列表里删除该项
                        // that.form.fileList = that.form.fileList.filter((
                        // 	item, index) => {
                        // 	return item.name !== param.file.name &&
                        // 		item.status !== "ready"
                        // });
                        that.$alert(
                          "新增文件上传失败，请重新上传",
                          "出错提示",
                          {
                            type: "error",
                          }
                        );
                        //param.onError();
                        return false;
                      }
                    })
                    .catch(function(err) {
                      // console.log(err);
                      // console.log('上传失败，请重新上传2');

                      //上传失败则从列表里删除该项
                      // that.form.fileList = that.form.fileList.filter((item,
                      // 	index) => {
                      // 	return item.name !== param.file.name && item
                      // 		.status !== "ready"
                      // });

                      that.$alert("上传失败，请重新上传", "出错提示", {
                        type: "error",
                      });
                      //param.onError();
                      return false;
                    });
                }

                // 从服务器上删除用户编辑表单时从列表上删除的旧上传文件。
                that.form.deleteFileIds.forEach((fItem) => {
                  let fData = {
                    id: fItem,
                  };
                  deleteFile(fData)
                    .then((res3) => {
                      // console.log(JSON.parse(JSON.stringify(res3)));
                      // console.log('66666666666'+i)
                      if (res3.data.success) {
                        that.form.fileList = that.form.fileList.filter(
                          (item4) => {
                            return item4.uid !== fItem;
                          }
                        );
                        that.form.deleteFileIds = that.form.deleteFileIds.filter(
                          (item5) => {
                            return item5 == fItem;
                          }
                        );
                        return true;
                      } else {
                        that.$alert("删除失败，请再试一次吧。", "出错提示", {
                          type: "error",
                        });
                        return false;
                      }
                    })
                    .catch(function(err) {
                      console.log(err);
                      return false;
                    });
                });

                that.$notify({
                  title: "已成功编辑此资料项。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
                // that.$router.push({
                //   name: "BimDatabank",
                //   params: {},
                // });
              } else {
                that.$alert("更新此资料项失败了，请再试一次吧~", "更新失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          } else {
            addBimDataBankData(dData).then((res) => {
              //console.log(JSON.parse(JSON.stringify(res)));

              if (res.data.success && res.data.data > 0) {
                //有文件才上传，没文件不必上传。
                if (
                  that.form.tempFileList &&
                  that.form.tempFileList.length > 0
                ) {
                  //根据返回的新增数据id进一步上传文件。
                  let fileUploadFormData = new FormData();
                  that.form.tempFileList.forEach((item) => {
                    fileUploadFormData.append("files", item);
                  });
                  fileUploadFormData.append("businessType", "BimDataBankData");
                  fileUploadFormData.append("businessId", res.data.data);
                  fileUploadFormData.append(
                    "projectId",
                    window.sessionStorage.getItem("nowProjectId")
                  );
                  // console.log(fileUploadFormData);
                  // console.log(666);
                  axios
                    .post(
                      "/baseIP/sysFileInfo/uploadmultiple",
                      fileUploadFormData,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization:
                            "Bearer " + window.sessionStorage.getItem("token"),
                          "X-Authorization":
                            "Bearer " +
                            window.sessionStorage.getItem("refreshToken"),
                        },
                      }
                    )
                    .then(function(res2) {
                      if (res2.data.success && res2.data.data) {
                        // let fileObj = {
                        // 	'name': param.file.name,
                        // 	'url': '',
                        // 	'id': res2.data.data,
                        // }
                        // that.form.tempFileList.push(fileObj);
                        // that.form.fileList = that.form.fileList.map((i) => {
                        // 	if (i.name === param.file.name) {
                        // 		i.id = res2.data.data;
                        // 	}
                        // 	return i;
                        // });
                        //param.onSuccess(); //返回promise，调用文件上传成功方法 :on-success="uploadSuccess"
                        //return false;
                        //return false;
                        //获取文件详情
                        // let fData={
                        // 	id:parseInt(res.data.data)
                        // }
                        // getFileDetail(fData).then(response => {
                        // 	console.log(JSON.parse(JSON.stringify(response)));
                        // 	console.log('66666666666')
                        // 	if(res.data.success&&res.data.data){
                        // 	}
                        // }).catch(function(err) {
                        //	console.log(err)
                        // 	console.log('上传文件失败')
                        // })
                      } else {
                        // console.log(err);
                        // console.log('文件 ' + param.file.name + ' 上传失败，请重新上传');
                        //上传失败则从列表里删除该项
                        // that.form.fileList = that.form.fileList.filter((
                        // 	item, index) => {
                        // 	return item.name !== param.file.name &&
                        // 		item.status !== "ready"
                        // });
                        that.$alert("文件上传失败，请重新上传", "友情提示", {
                          confirmButtonText: "确定",
                          type: "error",
                          callback: (action) => {
                            //跳转到编辑该资料项的页面，因为这时数据表里已经有该条资料项记录了。
                            // 不能跳转到当前路由，会报错。
                            // that.$router.push({
                            // 	name: 'BimDatabankData',
                            // 	params: {dataId:res.data.data},
                            // });
                            window.sessionStorage.setItem(
                              "BimDatabankDataEditUrlId",
                              res.data.data
                            );
                            location.reload(); //刷新当前页面
                          },
                        });
                        //param.onError();
                        return false;
                      }
                    })
                    .catch(function(err) {
                      // console.log(err);
                      // console.log('上传失败，请重新上传2');

                      //上传失败则从列表里删除该项
                      // that.form.fileList = that.form.fileList.filter((item,
                      // 	index) => {
                      // 	return item.name !== param.file.name && item
                      // 		.status !== "ready"
                      // });

                      // that.$alert('上传失败，请重新上传', '出错提示', {
                      // 	type: 'error'
                      // });
                      // param.onError();
                      that.$alert("文件上传失败，请重新上传", "友情提示", {
                        confirmButtonText: "确定",
                        type: "error",
                        callback: (action) => {
                          //跳转到编辑该资料项的页面，因为这时数据表里已经有该条资料项记录了。
                          // 不能跳转到当前路由，会报错。
                          // that.$router.push({
                          // 	name: 'BimDatabankData',
                          // 	params: {dataId:res.data.data},
                          // });
                          window.sessionStorage.setItem(
                            "BimDatabankDataEditUrlId",
                            res.data.data
                          );
                          location.reload(); //刷新当前页面
                        },
                      });
                    });
                  fileUploadFormData = new FormData(); //重置临时文件变量。
                  that.form.fileList = [];
                  that.form.fileData = "";
                  that.form.tempFileList = [];
                }
                that
                  .$confirm("已成功新增资料项，是否返回资料库主界面？")
                  .then((_) => {
                    // 重置一些表单值，但不重置所属目录id，方便用户在当前目录下连续新增资料项。
                    that.form.name = "";
                    that.form.remarks = "";
                    that.form.registerTime = "";
                    that.$router.push({
                      name: "BimDatabank",
                      params: {},
                    });
                  })
                  .catch((_) => {});
              } else {
                that.$alert("新增资料项失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          }
        }
      });
    },
    handleChange(file, fileList) {
      //文件状态改变【添加文件、上传成功、上传失败】时调用此方法。
      // 下面这样写会导致一次上传一个以上的文件时，最后一个文件被删除并提示"当前文件已经存在"，所以先注释。
      // let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
      // if (existFile) {
      // 	this.$message.error('当前文件已经存在！');
      // 	fileList.pop();
      // }

      this.form.fileList = fileList;
      //只保留最后上传的三个文件。
      //this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      //文件验证【后缀名|文件类型、文件大小】应该写在这里。

      //不允许上传同名文件。如果后面改为允许的话，要注意排查删除同名文件的问题【根据名字找文件得改为根据文件id来找文件】。
      let existFile = this.form.fileList
        .slice(0, this.form.fileList.length - 1)
        .find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error(
          "您上传了同名文件：" + file.name + "，已为您移除。"
        );
        return false;
      }

      // console.log(file);
      //避免编辑表单时旧上传文件导致验证不通过。
      //if (file.name) {
      let FileExt = file.name.replace(/.+\./, "");

      if (
        [
          "jpg",
          "png",
          "txt",
          "zip",
          "rar",
          "pdf",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "mp4",
        ].indexOf(FileExt.toLowerCase()) === -1
      ) {
        this.$message.error(
          "此处只允许上传后缀名为jpg、png、txt、pdf、doc、docx、xls、xlsx、mp4、zip或rar的附件！"
        );
        return false;
      }
      //}

      //const fileSizeLimit = this.form.fileList.every(file => file.size / 1024 / 1024 <=5);
      //console.log(this.form.fileList.length);
      if (file.size > 100 * 1024 * 1024) {
        this.$message.error("上传的单个文件大小不能超过100MB！");
        return false;
      }

      //return false; //先return false，阻止默认的给列表添加文件项，上传成功后再调用代码给列表添加文件项。
    },

    uploadFile(param) {
      this.form.tempFileList.push(param.file);
      // 如果是新增，那么如果上传的是该资料项的首个文件，用户还没有给资料项输入名称，那么就将用户上传的第一个文件的名字作为资料项名称。
      // 如果是编辑，那么如果用户之前没有上传文件，这次是上传的是该资料项的首个文件，用户还没有给资料项输入名称，那么就将用户这次上传的第一个文件的名字作为资料项名称。
      if (
        (!this.isEdit && this.isFirstFile && this.form.name.trim() === "") ||
        (this.isEdit &&
          this.form.fileList.length === 0 &&
          this.isFirstFile &&
          this.form.name.trim() === "")
      ) {
        this.form.name = param.file.name
          .split(".")
          .slice(0, -1)
          .join("."); //除去文件后缀名。
        this.isFirstFile = false;
      }
      // console.log(param.file.name);
      // console.log(66);
    },
    // handleExceed(files, fileList) {
    // 	//上传文件数量超过限制数量时调用此方法。
    // 	this.$message.warning(`最多上传3个文件，您上传了 ${files.length + fileList.length} 个文件，已超过此数量。`);
    // },

    beforeRemove(file, fileList) {
      //删除文件前调用，若返回false或者返回Promise且被reject，则停止删除。

      // console.log(JSON.parse(JSON.stringify(file)));
      // console.log(JSON.parse(JSON.stringify(fileList)));
      // console.log(123);
      if (file.status !== "ready") {
        this.$confirm(
          "您确定要从文件列表中删除文件 " + file.name + " 吗？",
          "确认提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确认删除",
            cancelButtonText: "取消删除",
          }
        )
          .then(() => {
            this.handleRemove(file, fileList);
          })
          .catch(function(err) {
            console.log(err);
          });
        // .catch(action => {
        // 	this.$message({
        // 		type: 'info',
        // 		message: action === 'cancel' ?
        // 			'放弃保存并离开页面' : '停留在当前页面'
        // 	})
        // });

        //先return false；阻止默认的删除。在调用服务器删除文件接口成功后再调用handleRemove方法。
        return false;
      }
    },
    handleRemove(file, fileList) {
      //console.log(JSON.parse(JSON.stringify(file)));
      //console.log(JSON.parse(JSON.stringify(fileList)));
      //console.log(JSON.parse(JSON.stringify(this.form.tempFileList)));
      let dFileIndex = this.form.tempFileList.findIndex((item) => {
        return item.uid === file.uid;
      });
      if (dFileIndex !== -1) {
        //如果在临时文件里，则直接从临时文件中删除。
        this.form.tempFileList.splice(dFileIndex, 1);
      } else {
        //如果不在临时文件里，表明是编辑时旧的上传文件，那么就存到this.form.deleteFileIds中，等到提交表单时再删。
        if (this.isEdit) {
          this.form.deleteFileIds.push(file.id);
          this.form.fileList = this.form.fileList.filter((item2) => {
            return item2.id !== file.id;
          });
        }
        //console.log(JSON.parse(JSON.stringify(this.form.deleteFileIds)));
      }
    },
    handlePreview(file) {
      let that = this;
      //点击文件列表中已上传的文件时调用此方法，可在此写预览文件内容的代码。
      //['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xls', 'xlsx']

      //如果是图片则预览，其它符合文件则下载。
      //当然，本页面现在只凭后缀名检测文件并不严谨，但目前先这样。
      let FileExt = file.name.replace(/.+\./, "");
      let fileUrl = "" + file.name;
      if (["jpg", "png"].indexOf(FileExt.toLowerCase()) !== -1) {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/preview", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            const dataInfo = res.data;
            let reader = new window.FileReader();
            // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
            reader.readAsArrayBuffer(dataInfo);
            reader.onload = function(e) {
              const result = e.target.result;
              const contentType = dataInfo.type;
              // 生成blob图片,需要参数(字节数组, 文件类型)
              const blob = new Blob([result], {
                type: contentType,
              });
              // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
              const url = window.URL.createObjectURL(blob);
              console.log(url); // 产生一个类似 blob:d3958f5c-0777-0845-9dcf-2cb28783acaf 这样的URL字符串
              that.dialogVisible = true;
              that.dialogImageUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
            };
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      } else {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/download", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      }
    },
    uploadSuccess(reponse, file, fileList) {
      //alert('触发！');
      //console.log('触发！');
    },
    downloadFile(res) {
      let blob = new Blob([res.data], {
        type: "application/octet-stream;charset=UTF-8",
      });
      let contentDisposition = res.headers["content-disposition"];
      let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      let result = patt.exec(contentDisposition);
      let filename = result[1];
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      let reg = /^["](.*)["]$/g;
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = decodeURI(filename.replace(reg, "$1")); //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放通过调用URL.createObjectURL()创建的URL对象。
    },
    resetForm() {
      this.form = {
        id: "",
        categoryId: "",
        categoryName: "",
        name: "",
        remarks: "",
        fileList: [], //upload多文件数组
        fileData: "", //文件上传数据（多文件合一）。
        tempFileList: [], //还未保存到服务器上的用户上传的文件。
        registerTime: "",
        newInsertId: "", //新增数据的id
        deleteFileIds: [], //用户编辑页面时删除的文件id。等用户确认提交表单后再删除服务器上文件。
      };
      //this.dialogFormVisible = false;
    },
    formSubmit() {
      //this.append();
      //console.log(JSON.parse(JSON.stringify(this.form)));
      let newChild = {
        id: id++,
        label: this.form.name,
        children: [],
      };

      this.data.push(newChild);
      this.dialogFormVisible = false;
    },
    // viewDetails(item) {
    //   console.log(this.form.fileList);
    //   if (item.fileList.length == 1) {
    //     this.$refs.PDF.isShow = true;
    //     this.pdfSrc =
    //       process.env.VUE_APP_LOCAL_RESOURCES_PATH +
    //       item.fileList[0].filePath +
    //       "/" +
    //       item.fileList[0].fileObjectName;
    //   } else if (item.fileList.length > 1) {
    //     this.dialogVisible = true;
    //     this.fileList = item.fileList;
    //   } else {
    //     this.$message({
    //       message: "暂无附件",
    //       type: "warning",
    //       duration: 1500,
    //     });
    //   }
    // },
  },
  watch: {},
  destroyed() {
    window.sessionStorage.removeItem("BimDatabankDataEditUrlId");
  },
};
